<template>
  <div class="discoverpopup-fullscreen" @click.stop="$emit('close')">
    <div class="discover-container">
      <ExpandDiscovered v-if="moveKey == 'expand'" />
      <SlingshotDiscovered v-else-if="moveKey == 'slingshot'" />
      <TripleClickDiscovered v-else-if="moveKey == 'tripleclick'" />
      <SpinnerDiscovered v-else-if="moveKey == 'spinner'" />
      <RoundTheOutsideDiscovered v-else-if="moveKey == 'roundtheoutside'" />
      <SlideRotateDiscovered v-else-if="moveKey == 'sliderotate'" />
    </div>
  </div>
</template>

<script>
import ExpandDiscovered from '@/components/ExpandDiscovered.vue'
import SlingshotDiscovered from '@/components/SlingshotDiscovered.vue'
import TripleClickDiscovered from '@/components/TripleClickDiscovered.vue'
import SpinnerDiscovered from '@/components/SpinnerDiscovered.vue'
import RoundTheOutsideDiscovered from '@/components/RoundTheOutsideDiscovered.vue'
import SlideRotateDiscovered from '@/components/SlideRotateDiscovered.vue'

export default {
  name: 'DiscoverPopup',
  props: {
    moveKey: String,
  },
  components: {
    SlingshotDiscovered,
    ExpandDiscovered,
    TripleClickDiscovered,
    SpinnerDiscovered,
    RoundTheOutsideDiscovered,
    SlideRotateDiscovered,
  },
}
</script>

<style>
.discoverpopup-fullscreen {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0.8);
  transition: background-color 0.3s;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.discover-container {
  background-color: #003745;
  border-radius: 10px;
  max-width: calc(100% - 8rem);
  z-index: 1000;
  padding: 3rem;
  font-family: 'Montserrat', sans-serif;
  color: #cdf4dd;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s, transform 0.3s;
}
</style>
